import animation from "../images/orbits-loader.gif";

export default ({ height, width }: { height: number; width: number }) => (
  <img src={animation} style={{ height, width }} />
);
